import React from 'react'
import ServicesImage from '../img/services2.svg'

const Services = () => {
    return(
      <>
        {/* this is the services page */}
        <h1 className="text-5xl mt-14 text-center font-bold max-md:text-5xl max-md:text-center max-sm:text-4xl">OUR SERVICES</h1>
        <section className="py-5 grid grid-cols-2 max-[1100px]:grid-cols-1" id="services">
          <div className="w-full px-10 max-[1100px]:w-full">
            <div className="grid grid-cols-2 gap-12 items-center justify-center mt-14 max-sm:grid max-sm:grid-cols-1">
              <div className="bg-gray-100 px-7 py-10 text-center rounded-3xl shadow-lg">
                <h2 className="font-semibold text-teal-900">ROADS</h2>
                <p className="mt-7 max-[md]:leading-[30px] max-sm:leading-[40px] text-[#3d3d3d]">Expert road design and inspection to ensure optimal safety and regulatory compliance.</p>
              </div>
              <div className="bg-gray-100 px-7 py-10 text-center rounded-3xl shadow-lg">
                <h2 className="font-semibold text-teal-900">DAMS</h2>
                <p className="mt-7 max-md:leading-[30px] max-sm:leading-[40px] text-[#3d3d3d]">"Advanced dam engineering, focused on safety and environmental sustainability.</p>
              </div>
              <div className="bg-gray-100 px-7 py-10 text-center rounded-3xl shadow-lg">
                <h2 className="font-semibold text-teal-900">BUILDINGS</h2>
                <p className="mt-7 max-md:leading-[30px] max-sm:leading-[40px] text-[#3d3d3d]">Comprehensive building design services that blend functionality with aesthetic appeal.</p>
              </div>
              <div className="bg-gray-100 px-7 py-10 text-center rounded-3xl shadow-lg">
                <h2 className="font-semibold text-teal-900">EIA</h2>
                <p className="mt-7 max-md:leading-[30px] max-sm:leading-[40px] text-[#3d3d3d]">Conducting thorough assessments to promote sustainable development and inform decisions.</p>
              </div>
            </div>
          </div>
          <div className="w-full mt-2 flex items-center justify-center max-[1100px]:mt-14">
            <img src={ServicesImage} alt="services" width="95%" className='max-[1100px]:w-3/4'/>
          </div>
        </section>
      </>
    )
}

export default Services